import type { E_ShareType } from '@eureka/services/src/types/share';

export interface SharedUserListData {
  work_project_id: string;
  page: number;
  limit: number;
}

export interface ShareAuthCheckData {
  data_id: string;
  data_type: E_ShareType;
}

export interface ShareOwnerData {
  owner_id: string;
  owner_name: string;
  can_copy: boolean;
  can_create_share: boolean;
}

export interface ShareLinkData {
  id: string;
  type: E_ShareType;
}

export interface ShareLinkResponse {
  share_id: string;
}

export interface InviteByEmailData {
  share_id: string;
  share_emails: string[];
  from?: string;
}

export interface InviteProjectByEmailData {
  work_project_id: string;
  share_emails: string[];
  from?: string;
}

export enum ShareTaskStatus {
  PENDING = 300,
  SUCCESS = 200,
  FAILED = 500,
}

export interface ExecuteShareTaskResponse {
  new_data_id: string;
  status: ShareTaskStatus;
}

export interface DuplicateModuleData {
  loading: boolean;
  status: ShareTaskStatus;
}

export interface ShareOwnerResponse {
  /**
   * 分享id
   */
  ownerId: string;
  /**
   * 分享者名称
   */
  ownerName: string;
  /**
   * 是否可以进行复制
   */
  canCopy: boolean;
  /**
   * 是否可以进行分享
   */
  canCreateShare: boolean;
}

export interface AuthModuleData {
  isShare: boolean;
  isLogin: boolean;
  ownerName: string;
  ownerId: string;
  canCopy: boolean;
  /**
   * 是否可以进行分享
   */
  canCreateShare: boolean;
}

export interface AuthPageParams {
  currentDetailId: string;
  currentPageType: E_ShareType | '';
}
